var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in","enter-active-class":"animated fadeIn faster","leave-active-class":"animated fadeOut faster"}},[_c('span',{key:_vm.value},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }